import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=11b33ed6&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=11b33ed6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b33ed6",
  null
  
)

export default component.exports